import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SearchOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"search_off"}/>
}
